import { Component, inject, input, output } from '@angular/core';
import { TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe, TranslationService } from '../../../../core/i18n';
import type { DeliveryServiceOffering } from './delivery-service-matrix';
import {
  formatCurrencyAmount,
  resolveCommitmentLabel,
  resolveServiceDisplayName,
} from './delivery-service-matrix';

/**
 * Selectable Purolator service offering card for a delivery date column.
 */
@Component({
  selector: 'app-delivery-service-card',
  imports: [TranslatePipe, TypographyComponent],
  templateUrl: './delivery-service-card.html',
  styleUrl: './delivery-service-card.scss',
})
export class DeliveryServiceCard {
  private readonly translation = inject(TranslationService);

  readonly offering = input.required<DeliveryServiceOffering>();
  readonly selected = input(false);
  readonly fastest = input(false);
  readonly mostEconomical = input(false);
  readonly offeringSelect = output<string>();

  protected readonly formatCurrencyAmount = formatCurrencyAmount;

  /**
   * Resolves the card title from products/selection `descEn` / `descFr` for the active locale.
   */
  protected serviceDisplayName(): string {
    this.translation.revision();
    const locale = this.translation.locale() === 'fr' ? 'fr' : 'en';
    return resolveServiceDisplayName(this.offering(), locale);
  }

  /**
   * Returns the backend serviceTimeEnglish / serviceTimeFrench commitment line for the active locale.
   */
  protected commitmentLabel(): string {
    this.translation.revision();
    const locale = this.translation.locale() === 'fr' ? 'fr' : 'en';
    return resolveCommitmentLabel(this.offering(), locale);
  }

  /**
   * Emits the product code when the user activates the card.
   */
  protected onSelect(): void {
    this.offeringSelect.emit(this.offering().productCode);
  }
}
